import React from 'react';


const MetaMaskLink = () => {
    return (
        <a className="externalLink" href="https://metamask.io/" target="_blank" rel="noreferrer">MetaMask</a>
    );
}

export default MetaMaskLink;